export default __webpack_public_path__ + "static/media/icn_map_pin_non_compliant.42edf343.svg";